<template>
  <div class="modelBox" @click.stop="$refs.modelTree.showContextMenu = false">
    <div class="tree-box">
      <div class="model-tree" :style="{ width: showTree ? '350px' : 0, height: '600px' }">
        <ModelTree  @importSuc="importSuc" @change="changeModelId" :currentModel="modelId" ref="modelTree" v-show="showTree" @resetModelId="resetModelId"></ModelTree>

      </div>
      <span class="close-tree" @click="showTree = !showTree">
        <i :class="showTree ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"></i>
      </span>
    </div>
    <div class="model-content">
      <div v-if="modelId" style="height:100%;width: 100%;">
        <el-tabs v-model="tabCur" :before-leave="changeTabCur">
           <el-tab-pane label="基础信息" name="0"></el-tab-pane>
          <el-tab-pane label="数据字段" name="1"></el-tab-pane>

        </el-tabs>
        <div style="height:calc(100% - 24px)">
            <ModelForm @submitSave="submitSave" :modelId="modelId" v-if="tabCur == '0'" >基础信息</ModelForm>
            <TextField :modelId="modelId" :data_inputed="data_inputed" v-if="tabCur == '1'" >数据字段</TextField>

        </div>
      </div>
      <div class="empty" v-else>
        <i class="empty-icon el-icon-s-opportunity"></i>
        <p>请先选择模型</p>
      </div>
    </div>
  </div>
</template>

<script>
import ModelTree from './components/ModelTree'
import ModelForm from './components/ModelForm'
import TextField from './components/TextField'
// import TextField from './components/TextField'
// import FieldIndex from './components/FieldIndex'
// import Form from './components/Form'
// import H5Form from './components/H5Form'
// import AuditFlow from './components/AuditFlow'
// import ModelRole from './components/ModelRole'
// import ModelUser from './components/ModelUser'
// import instance from './utils/FormDesignLock'
// import { setCurrentPath } from '@/utils/auth'

export default {
  components: {
    ModelTree,
    ModelForm,
    TextField
    // TextField,
    // Form,
    // H5Form,
    // AuditFlow,
    // FieldIndex,
    // ModelUser,
    // ModelRole
  },
  name: 'index',
  data() {
    return {
      tabCur: '0',
      modelId: '',
      level: '',
      showTree: true,
      // instance: instance,
      data_inputed:0
    }
  },
  // watch: {
  //   isChange: {
  //     handler(val) {
  //       console.log('变更', val)
  //     },
  //     immediate: false,
  //     deep: true
  //   }
  // },
  // computed: {
  //   isChange() {
  //     return this.instance ? this.instance.isChange : false
  //   },
  // },
  //路由跳转拦截
  // async beforeRouteLeave(to, from, next) {
  //   try {
  //     const validate = await this.instance.onValidateChange()
  //     if (validate) next()
  //   } catch (error) {}
  // },
  methods: {
    // 模型切换拦截
    async changeModelId(param) {
      try {
        if (param.id === this.modelId) return false

        this.data_inputed = param.data_inputed
        this.tabCur = '0'
        if (!param.level) {
          this.modelId = param.id
        } else {
          this.modelId = ''
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    // tab切换拦截
    async changeTabCur(activeName, oldActiveName) {
        console.log(activeName,oldActiveName)
    },
    // 清除当前modelID
    resetModelId(){
      this.modelId = ''
    },
    // 导入模板成功
    importSuc() {
      if(this.tabCur == '0' && this.modelId) {
        this.$refs.TextField.getFieldList()
      }
    },
    submitSave(){
        this.$refs.modelTree.getModelList();
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-scrollbar__wrap {
  // overflow-x: hidden;
}
::v-deep .el-scrollbar__view {
  height: 100%;
  width: 100%;
}
.modelBox {
  width: 100%;
  height: 100%;
  padding: 20px;
  display: flex;
  overflow: auto;
  box-sizing: border-box;
  .tree-box {
    height: 100%;
    position: relative;
    margin-right: 20px;
    .close-tree {
      position: absolute;
      width: 15px;
      height: 40px;
      right: -15px;
      top: 50%;
      border-radius: 0 4px 4px 0;
      transform: translateY(-50%);
      background-color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
  .model-tree {
    width: 350px;
    // min-width: 350px;
    height: 100%;
    background: #141C3A;
    border-radius: 10px;
    border: 1px solid #303E74;
    transition-property: width; /* 设置宽度有过渡效果 */
    transition-duration: 0.2s; /* 设置过渡时间为 3s */
    transition-delay: 0.1s;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .model-content {
    flex: auto;
    width: 0;
    height: 100%;

    .empty {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      color: #999999;

      .empty-icon {
        font-size: 200px;
        color: #b3d1fc;
        margin-bottom: 10px;
        transition: all 300ms;

        &:hover {
          color: #629ef5;
          transition: all 300ms;
        }
      }
    }
  }
}
</style>
